import { Box, CircularProgress } from '@cambridgeassessment/cambridge-ui';
import React, { memo } from 'react';

export type Props = {
  height?: number | string;
};

const Loader: React.FC<Props> = ({ height }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="100%"
      height={height || '100%'}
    >
      <CircularProgress data-testid="circular-progress" />
    </Box>
  );
};

export default memo(Loader);
